import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=08c7e4f2&scoped=true"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=08c7e4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7e4f2",
  null
  
)

export default component.exports